import { Navigate, useParams } from "react-router-dom";

/** /subjects/:id is a thin redirect into the lessons list filtered by subject. */
export function Subjects() {
  const { subjectId } = useParams();
  if (subjectId === "math" || subjectId?.toLowerCase() === "fnat") {
    return <Navigate to="/player/fnat" replace />;
  }
  return <Navigate to={`/lessons?subjectId=${subjectId}`} replace />;
}
